import {Pipe, PipeTransform} from '@angular/core';
import {DSAlgorithm, DSALGORITHMS} from "../model/DSAlgoritm";
import {DigestType, DIGESTTYPES} from "../model/DigestType";
// TODO(RZ-2562): Replace legacy VO types (TrustAnchorVO) with SDK equivalents (TrustAnchor)
import {TrustAnchorVO} from '../generate/TopLevelDomainVO';

@Pipe({
    name: 'trustAnchorValueExtractor',
    standalone: false
})
export class TrustAnchorValueExtractorPipe implements PipeTransform {

  keyAlgs: DSAlgorithm[] = DSALGORITHMS;

  transform(trustAnchors: TrustAnchorVO, args1: string): any {
    switch (args1) {
      case 'algorithm':
        return this.getAlgorithmValue(trustAnchors);
      case 'digestType':
        return DIGESTTYPES[trustAnchors.digestType].value;
    }
  }

  private getAlgorithmValue(trustAnchors: TrustAnchorVO): number {
    let algVal: number;
    DSALGORITHMS.forEach(value => {
      if (value.name === trustAnchors.algorithm) {
        algVal = value.value;
      }
    });

    return algVal;
  }
}
